import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('elasticpath'),
  hasConnectionStatus: false,
  titleToNamespace: true,
  avatarPath: avatars.elasticpath,
  logoPath: logos.elasticpath
});
